import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { DeleteDataOnServer, GetDataListFromServer } from "../../lib/api";
import {
  SOCIAL_DELETE,
  SOCIAL_LIST,
} from "../../lib/config";
import { QUERY_SOCIAL } from "../../lib/query_obj";
import { queryHandler } from "../../lib/global_functions";
import {
  Button,
  Col,
  Drawer,
  message,
  Popconfirm,
  Row,
  Space,
  Table,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import SocialForm from "./form";

export default function Social() {
  const { access_token, permissions, csrf_token, ui_size } = useSelector((state) => state.user);

  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [edit, setEdit] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const [pagin, setPagin] = useState({
    page_number: 1,
    per_page: 10,
    total: 0,
  });
  const [filter, setFilter] = useState({
    name: "",
    order_by: "created_at",
    order_type: "DESC",
  });

  async function getDataList(page_number, per_page) {
    setLoading(true);
    await GetDataListFromServer(
      SOCIAL_LIST,
      queryHandler(filter, QUERY_SOCIAL, { page_number, per_page }),
      access_token
    )
      .then(({ data: { data: res, total } }) => {
        setLoading(false);
        setPagin((prev) => ({ ...prev, page_number, per_page, total }));
        setList(res);
      })
      .catch((error) => {
        setLoading(false);
        message.error(error?.response?.data?.error || "Connection Error");
      });
  }

  useEffect(() => {
    getDataList(pagin.page_number, pagin.per_page);
  }, []);

  const columns = [
    {
      title: "Social media type",
      dataIndex: "social_media_type",
    },
    {
     title : "Link",
     dataIndex : "link_url"
    },
    {
      title: "Actions",
      dataIndex: "actions",
      width:"100px",
      render: (_, record) => (
        <Row justify="end">
        <Space>
          {permissions.includes("AGENT_UPDATE_SOCIAL") && (
            <Button
              type="primary"
              size={ui_size}
              onClick={() => editHandler(record)}
            >
              Edit
            </Button>
          )}
          {permissions.includes("AGENT_DELETE_SOCIAL") && (
            <Popconfirm
              title="Are you sure to delete?"
              onConfirm={() => deleteHandler(record.id)}
              okText="Yes"
              cancelText="No"
            >
              <Button size={ui_size} type="primary" danger>
                Delete
              </Button>
            </Popconfirm>
          )}
        </Space>
        </Row>
      ),
    },
  ];
  const openDrawer = () => setShowForm(true);

  function editHandler(record) {
    setShowForm(true);
    setEdit(record);
  }

  function closeDrawer(key) {
    setShowForm(false);
    setEdit(false);
    if (key) {
      getDataList(pagin.page_number, pagin.per_page);
    }
  }

  async function deleteHandler(id) {
    setLoading(true);

    await DeleteDataOnServer(SOCIAL_DELETE, id, access_token, csrf_token)
      .then(() => {
        setLoading(false);
        toast.success("Deleted social successfully");
        getDataList(pagin.page_number, pagin.per_page);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Delete failed");
      });
  }


  return (
    <>
      <Row gutter={[0, 16]} justify={"end"}>
        <Col>
          {permissions.includes("AGENT_CREATE_SOCIAL") && (
            <Button size={ui_size} type="primary" onClick={openDrawer} icon={<PlusOutlined />}>
              New Social Media
            </Button>
          )}
        </Col>
        <Col span={24}>
          <Table
            size={ui_size}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={list}
            loading={loading}
            pagination={{
              total: pagin.total,
              defaultCurrent: 1,
              defaultPageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: [10, 20, 50],
              onChange: (pageNumber, perPage) => {
                getDataList(pageNumber, perPage);
              },
            }}
           
          />
        </Col>
      </Row>
      <Drawer
        open={showForm}
        title={edit ? "Update Social Form" : "Create Social Form"}
        onClose={() => closeDrawer()}
        destroyOnClose
        placement="right"
        width={560}
      >
        <SocialForm closeDrawer={closeDrawer} edit={edit} />
      </Drawer>
    </>
  );
}

